import { ThresholdValue } from '@src/types/PointConfig';

export function colorForValue(
  value: number,
  thresholdValues?: Array<ThresholdValue>,
): string | undefined {
  if (!thresholdValues || thresholdValues.length === 0) {
    return undefined;
  }

  for (const threshold of thresholdValues) {
    const minOk =
      threshold.min.value === null ? true : value >= threshold.min.value;
    const maxOk =
      threshold.max.value === null ? true : value <= threshold.max.value;

    if (minOk && maxOk) {
      // For values within the threshold, consistently return min.color if defined, else max.color if defined, else undefined
      if (threshold.min.color !== undefined && threshold.min.color !== null) {
        return threshold.min.color;
      }
      if (threshold.max.color !== undefined && threshold.max.color !== null) {
        return threshold.max.color;
      }
      return undefined;
    }
  }
  return undefined;
}

export function validateThresholds(thresholds: Array<ThresholdValue>): {
  valid: boolean;
  sorted: Array<ThresholdValue>;
  error?: string;
} {
  if (!thresholds || thresholds.length === 0) {
    return { valid: true, sorted: [] };
  }

  const sorted = [...thresholds].sort((a, b) => {
    const minA = a.min.value ?? -Infinity;
    const minB = b.min.value ?? -Infinity;
    return minA - minB;
  });

  for (let i = 0; i < sorted.length; i++) {
    const t = sorted[i];

    if (
      t.min.value != null &&
      t.max.value != null &&
      t.min.value > t.max.value
    ) {
      return {
        valid: false,
        sorted,
        error: `Threshold ${i + 1}: min value (${t.min.value}) cannot be greater than max value (${t.max.value})`,
      };
    }

    if (i > 0) {
      const prev = sorted[i - 1];
      const prevMax = prev.max.value ?? Infinity;
      const currMin = t.min.value ?? -Infinity;

      if (prevMax > currMin) {
        return {
          valid: false,
          sorted,
          error: `Threshold ${i + 1} overlaps with threshold ${i}: previous max (${prevMax}) must be less than or equal to current min (${currMin})`,
        };
      }
    }
  }

  return { valid: true, sorted };
}
